import axios from 'axios';
import {tool} from './tool.js';
import {Message} from 'element-ui';
import router from '../../router.js';

const service = axios.create({
  timeout: 15000 // 请求超时时间
});

service.interceptors.request.use(config => {
  config.headers['token'] = tool.getCookie('token');
  return config;
}, error => {
  return Promise.reject(error);
});

service.interceptors.response.use(
    (res) => {
      console.log(res);
      if (res.data.code === 200) {
        return res.data;
      } else {
        tool.message(res.data.message, 'error');
        return Promise.reject(res.data);
      }
    },
    (error) => {
      let r = error.response;
      //console.log(r);
      switch (r.status) {
        case 401:
          tool.message(r.data.msg, 'error');
          setTimeout(() => {
            router.push({path: 'login'});
          }, 200);
          break;
        default:
          tool.message(r.data.msg, 'error');
      }
      return Promise.reject(error);
    }
);

export default service;

